import { FC } from "react";

export const ExpiredBannerTitle: FC = () => <span>This work packet has expired</span>;

export const ExpiredBannerBody: FC = () => (
  <>
    This work packet can still be included in disputes as needed, but has surpassed the 2 year limit (5 year limit for
    non-US/CA stores).
  </>
);
